<svg class="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    class="stroke-danger-bright fill-danger-bright"
    d="M12 3 2 20h20L12 3Z"
    stroke-width="2"
    stroke-linejoin="round" />
  <path class="stroke-bg-white" d="M12 9.5v4.5" stroke-width="2" stroke-linecap="round" />
  <circle class="fill-bg-white" cx="12" cy="17" r="1.1" />
</svg>
